var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-table',{attrs:{"columns":_vm.columns,"create-route":{
          name: 'arrival-temperatures.create'
      },"filters":_vm.filters,"pagination":true,"repository-func":_vm.repositoryFunc,"identifier":"arrivalTemperatureTable","title":"Températures d'arrivage"},scopedSlots:_vm._u([{key:"temperature-template",fn:function({ row }){return [_c('span',{staticClass:"font-semibold tracking-tight text-luxcaddy-700"},[_vm._v(_vm._s(row.temperature)+" °C")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }